import { Box, Flex } from '@chakra-ui/react';
import { EnrollmentProvider } from './pages/enrollment/EnrollmentContext';
import { Navigation } from './navigation/Navigation';
import { NavigationBadgesProvider } from './navigation/NavigationBadgesContext';
import { Outlet } from 'react-router-dom';
import { STAGE } from './config';
import { Toaster } from './components/ui/toaster';

function EnvMarker() {
    if (STAGE === 'PRODUCTION') return null;

    const borderColor = STAGE === 'TEST' ? 'gray.300' : 'gray.600';

    return (
        <Box
            position="fixed"
            top={0}
            zIndex={999}
            width="100%"
            height="1px"
            opacity={0.7}
            borderBottomWidth="2px"
            borderBottomStyle="dashed"
            color={borderColor}
            pointerEvents="none"
        />
    );
}

export function Root() {
    return (
        <EnrollmentProvider>
            <NavigationBadgesProvider>
                <Flex h="100vh" flexDirection="column">
                    <EnvMarker />
                    <Navigation />
                    <Box
                        flexGrow={1}
                        overflow="scroll"
                    >
                        <Outlet/>
                    </Box>
                    <Toaster />
                </Flex>
            </NavigationBadgesProvider>
        </EnrollmentProvider>
    );
}